import { Box, Typography } from '@mui/material';
import { EmojiEvents as TrophyIcon } from '@mui/icons-material';
import { WinnerCard } from './WinnerCard';
import type { WinnerGroup } from './usePublicBoardWinners';
import type { Board } from '../../types';

interface WinnersGridProps {
  winnerGroups: WinnerGroup[];
  board: Board;
}

export const WinnersGrid: React.FC<WinnersGridProps> = ({
  winnerGroups,
  board,
}) => {
  if (winnerGroups.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 8, px: 3 }}>
        <TrophyIcon
          sx={{
            fontSize: '3rem',
            color: 'rgba(184, 134, 11, 0.25)',
            mb: 2,
          }}
        />
        <Typography
          variant="h6"
          sx={{ mb: 1, fontWeight: 700, color: 'text.secondary' }}
        >
          No winners yet
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Scores haven&apos;t been recorded yet. Check back once the game starts!
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
        gap: 2,
        px: { xs: 2, md: 3 },
        py: 3,
        maxWidth: 900,
        mx: 'auto',
      }}
    >
      {winnerGroups.map((group, index) => (
        <WinnerCard
          key={group.mainHit.id}
          group={group}
          homeTeam={board.homeTeam}
          awayTeam={board.awayTeam}
          index={index}
        />
      ))}
    </Box>
  );
};
